import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

// The anchor of the program section on the event page (EventDetail scrolls to it once the program is
// in). An event card's PROGRAM button (MainEvent, OtherHeartsEvents) links to it.
export const PROGRAM_ANCHOR = 'programm';

// Whether the event has a public program the event page shows: the same rule as usePublicProgram
// (at least one public entry), without loading the people. The event cards show their PROGRAM button
// only then.
export const useHasPublicProgram = (slug) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setReady(false);
    if (!slug) return undefined;
    axios.get(`${API}/api/public/events/${encodeURIComponent(slug)}/program`)
      .then((r) => {
        if (!cancelled) setReady(Array.isArray(r.data?.entries) && r.data.entries.length > 0);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);
  return ready;
};

const Wrapper = styled(Link)`
  position: relative;
  display: block;
  max-width: 100%;
  margin-bottom: 20px;
  border-radius: 2px;

  &:focus-visible {
    outline: 3px solid #ffffff;
    outline-offset: 4px;
  }
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
  transition: transform 0.35s ease, box-shadow 0.35s ease;

  ${Wrapper}:hover & {
    transform: scale(1.015);
    box-shadow: 0 14px 28px rgba(0,0,0,0.28);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    ${Wrapper}:hover & { transform: none; }
  }
`;

const PlainImage = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
`;

// An event card's image as a link to the top of the event page. Without a slug there is no event
// page: the plain image, no link.
const EventImageLink = ({ slug, src, alt }) => {
  if (!slug) return <PlainImage src={src} alt={alt} />;

  return (
    <Wrapper to={`/events/${slug}`}>
      <Image src={src} alt={alt} />
    </Wrapper>
  );
};

export default EventImageLink;
